import React from 'react';
import { personName, ProjectTask, ProjectUser } from '../../services/projectService';
import { getAssetUrl } from '../../utils/assets';

export const formatTaskDueDate = (value?: string | null) => {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const dependencyLabel = (task: ProjectTask) => {
  const deps = task.dependsOn || [];
  if (!deps.length) return '—';
  return deps.map((dep) => (typeof dep === 'string' ? dep : dep.title)).join(', ');
};

export const assigneesOf = (task: ProjectTask): ProjectUser[] => {
  const list: ProjectUser[] = [];
  if (task.assignedTo) list.push(task.assignedTo);
  (task.participants || []).forEach((person) => {
    if (!list.some((item) => item._id === person._id)) list.push(person);
  });
  return list.slice(0, 3);
};

export const userInitials = (user: ProjectUser) => {
  const letters = `${user.firstName?.[0] || ''}${user.lastName?.[0] || ''}`.trim();
  return (letters || user.email?.[0] || '?').toUpperCase();
};

export const AssigneeAvatar: React.FC<{ user: ProjectUser }> = ({ user }) => {
  const src = getAssetUrl(user.avatar);
  if (src) {
    return <img src={src} alt={personName(user)} className="list-avatar" />;
  }
  return <span className="list-avatar list-avatar-fallback">{userInitials(user)}</span>;
};
